export const SET_PUBLISHING_PDFS = 'SET_PUBLISHING_PDFS';

export const setPublishingPDFs = (payload) => {
  return {
    type: SET_PUBLISHING_PDFS,
    payload: payload,
  };
};
